module.exports = [{"sku":1,"cat":7,"title":"Black Hamburger","price":"13.30","quantity":"1","total":"13.30","img":"burgur-1.png"},{"sku":2,"cat":5,"title":"BBQ Pizza TinTin","price":"13.30","quantity":"1","total":"13.30","img":"pizza_slide_4.png"}]


//////////////////
// WEBPACK FOOTER
// ./src/json/carts.json
// module id = DKfq
// module chunks = 0